import {
    CardType,
    PaymentMethod,
    PaymentOptions,
} from 'components/customer/Confirmation/Payment/entity/PaymentSession';
import {paymentOptionsSet} from 'components/customer/Confirmation/store/confirmationSlice';
import {PaymentMethodType} from 'components/manufacturer/Payments/entity/Setting';
import {useCallback} from 'react';
import {store, useAppDispatch} from 'store/customer';

export const useSetPaymentOptions = () => {
    const dispatch = useAppDispatch();

    const setPaymentOptions = useCallback(
        (payload: PaymentOptions, taxRate?: number) => {
            const state = store.getState();
            if (state.confirmation.accountPayAvailable) {
                const totalAmount = state.confirmation.fullAmount;
                const rate = Number(taxRate ?? 10);
                const taxAmount =
                    rate > 0 ? (totalAmount * rate) / (100 + rate) : 0;

                const paymentOption: PaymentMethod = {
                    paymentMethod: CardType.account,
                    baseAmount: totalAmount,
                    fullAmount: 0,
                    depositPercentage: 0,
                    platformFee: 0,
                    surchargeAmount: 0,
                    taxAmount: taxAmount,
                    platformFeeTaxAmount: 0,
                    surchargeTaxAmount: 0,
                    totalTaxAmount: taxAmount,
                    totalWithSurcharge: totalAmount,
                    surchargeApplied: false,
                    paymentType: PaymentMethodType.ACCOUNT,
                    remainingBalance: 0,
                };

                const modifiedPayload: PaymentOptions = {
                    ...payload,
                    account: {
                        paymentMethods: [paymentOption],
                    },
                };

                dispatch(paymentOptionsSet(modifiedPayload));
            } else {
                dispatch(paymentOptionsSet(payload));
            }
        },
        []
    );

    return {
        setPaymentOptions,
    };
};
